import React from "react"
import LayoutWithMenu from "../../layouts/LayoutWithMenu";
import { renderRoutes } from "react-router-config";

import { observer } from "mobx-react";

const StatsLayout = ({route}: {route?: any}) => {
    return <LayoutWithMenu route={route}>
            {renderRoutes(route.routes)}
    </LayoutWithMenu>
};


export default observer(StatsLayout)
